<template>

	<div>

        <Resumen :servicio="servicio" :path="url" :cliente="cliente"></Resumen>

    </div>

</template>

<script>
    import Resumen from './Resumen'

	export default {
		components: {Resumen},
        props: [
            'servicio',
            'cliente',
            'url'
        ],
        data() {
            return {

            }
        },
        watch: {

        },
        methods: {

        },
        mounted() {
            // console.log('--- paso tres component mounted ---')

        }
    };

</script>